module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-container clearfix"
  }, [_c('side-nav', {
    attrs: {
      "data": _vm.navConfig['zh-CN'],
      "base": "/component"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('router-view')], 1), _vm._v(" "), _c('mobile')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4a8d13f2!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/ExamplesDocsApp.vue
// module id = 172
// module chunks = 3